var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row-cols-1 sticky" },
    [
      _vm.userProfile
        ? _c(
            "div",
            { staticClass: "adam-header" },
            [
              _c(
                "adam-header-bar",
                {
                  class: [
                    "header",
                    {
                      "header--dev": _vm.isDevelopmentEnvironment,
                      "header--uat": _vm.isStagingEnvironment,
                      "header--prd": _vm.isProductionEnvironment,
                    },
                  ],
                  attrs: {
                    username: _vm.userProfile.name,
                    emailaddress: _vm.userProfile.email,
                  },
                  domProps: { showNotifications: false },
                  on: { "apps-click": _vm.clickDrawer },
                },
                [
                  _c(
                    "div",
                    { attrs: { slot: "headerContent" }, slot: "headerContent" },
                    [
                      _c("div", { staticClass: "row-header" }, [
                        _c("img", {
                          staticClass: "logo",
                          attrs: {
                            alt: "logo-coode-white",
                            src: require("adam.ui-core/assets/brand/logo-coode-white.svg"),
                          },
                        }),
                        _c("span", {
                          staticClass: "adam-header-bar adam-header__separator",
                        }),
                        _vm._v(" MSP Tool "),
                      ]),
                      _c("div", { staticClass: "extras" }, [
                        _c(
                          "a",
                          {
                            staticClass: "download-link",
                            on: { click: _vm.downloadHandbook },
                          },
                          [
                            _c("span", [
                              _vm._v(
                                " " + _vm._s(_vm.$t("userHandbook")) + " "
                              ),
                            ]),
                            _c("pui-icon", {
                              attrs: { "icon-name": "download" },
                            }),
                          ],
                          1
                        ),
                        _vm.dataLoaded
                          ? _c(
                              "button",
                              {
                                staticClass: "btn btn-secondary",
                                attrs: {
                                  id: "plannerButton",
                                  type: "button",
                                  "data-toggle": "collapse",
                                  "data-target": "#planner",
                                },
                              },
                              [
                                _c("font-awesome-icon", {
                                  attrs: { icon: "calendar-alt" },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]),
                    ]
                  ),
                  _c("div", [_vm._v("ceva")]),
                  _c(
                    "span",
                    {
                      attrs: { slot: "profileDetails" },
                      slot: "profileDetails",
                    },
                    [
                      _vm.isUserAdmin
                        ? _c(
                            "router-link",
                            { staticClass: "nav-link", attrs: { to: "/jobs" } },
                            [_vm._v(_vm._s(_vm.$t("jobs")))]
                          )
                        : _vm._e(),
                      _vm.isUserAdmin || _vm.hasPlantRights
                        ? _c(
                            "router-link",
                            {
                              staticClass: "nav-link",
                              attrs: { to: "/activity-log" },
                            },
                            [_vm._v(_vm._s(_vm.$t("activityLog")))]
                          )
                        : _vm._e(),
                      _c(
                        "button",
                        {
                          staticClass: "contact-ai-button",
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              return _vm.openQueryHub()
                            },
                          },
                        },
                        [
                          _c("span", { staticClass: "profile-action-icon" }),
                          _vm._v(
                            " " + _vm._s(_vm.$t("profile.contactAI")) + " "
                          ),
                        ]
                      ),
                      _c(
                        "button",
                        {
                          staticClass: "report-incident-link",
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              return _vm.sendToIncidentReporting()
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("reportIncident")) + " ")]
                      ),
                      _c("dropdown", {
                        staticClass: "language-dropdown",
                        attrs: {
                          text: "Language",
                          values: ["EN", "DE", "RU"],
                          selected:
                            _vm.selectedLanguage && _vm.selectedLanguage.label,
                        },
                        on: { change: _vm.setLanguage },
                      }),
                      _c(
                        "button",
                        {
                          staticClass: "logout-button",
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              return _vm.logout()
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("logout")) + " ")]
                      ),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "app-drawer",
                {
                  ref: "appDrawer",
                  domProps: {
                    data: _vm.applications,
                    labels: _vm.getAppDrawerLabels,
                    onClick: _vm.handleAppClick,
                  },
                },
                [
                  _c(
                    "span",
                    {
                      staticClass: "app-logo",
                      attrs: { slot: "appLogo" },
                      slot: "appLogo",
                    },
                    [
                      _c("img", {
                        attrs: {
                          alt: "logo-coode-rgb",
                          src: require("@/assets/img/logo-coode-light.svg"),
                        },
                      }),
                    ]
                  ),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
      _c("pui-navigation-toolbar", {
        attrs: {
          "link-items": _vm.links.map(function (link) {
            return {
              displayName: _vm.$t(link.name),
              href: link.path,
              isActive: _vm.$route.path == link.path,
            }
          }),
          "action-items": _vm.actionItems,
          "structure-select": {
            config: {
              placeholder: _vm.$t("pleaseSelectGroup"),
              listPlaceholders: [
                _vm.$t("pleaseSelectGroup"),
                _vm.$t("pleaseSelectPlant"),
                _vm.$t("pleaseSelectUnit"),
              ],
              options: _vm.structureMapping,
            },
            labelScope: _vm.labelScope,
            selectedId: _vm.selectedId,
          },
        },
        on: {
          "clicked:action": _vm.handlerFunction,
          "changed:active-route": _vm.handleNavigation,
          "selected:structure-select-id": _vm.changeEntry,
        },
      }),
      _c("div", { staticClass: "collapse", attrs: { id: "planner" } }, [
        _c(
          "div",
          { staticClass: "row col-12 justify-content-end" },
          [
            _c("pui-link", {
              attrs: {
                title: _vm.closeTitle,
                icon: "icon-close",
                variant: "secondary",
                "data-toggle": "collapse",
                "data-target": "#planner",
              },
              on: { click: _vm.closePlanner },
            }),
          ],
          1
        ),
        _c("div", { staticClass: "row justify-content-md-center" }, [
          _c("div", { staticClass: "col-5" }, [
            _c("h6", { staticClass: "picker-title" }, [
              _vm._v(" " + _vm._s(_vm.$t("startingDate")) + " "),
            ]),
            _c("div", { staticClass: "year-range-input mb-0 mt-1" }, [
              _c(
                "div",
                {
                  staticClass: "input-group",
                  class: {
                    "calendar-open": _vm.startDateCalendarOpen === true,
                  },
                },
                [
                  _c("div", { staticClass: "input-group-prepend" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-change-date left",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.data.decrementStartDate()
                          },
                        },
                      },
                      [
                        _c("font-awesome-icon", {
                          attrs: { icon: "angle-left" },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _c(
                    "div",
                    {
                      staticClass: "year-value text-center",
                      on: {
                        click: function ($event) {
                          return _vm.openStartDateCalendar()
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.data.selected.startDate) + " ")]
                  ),
                  _c("div", { staticClass: "input-group-append" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-change-date right",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.data.incrementStartDate()
                          },
                        },
                      },
                      [
                        _c("font-awesome-icon", {
                          attrs: { icon: "angle-right" },
                        }),
                      ],
                      1
                    ),
                  ]),
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "input-group",
                  class: [
                    { "show calendar": _vm.startDateCalendarOpen === true },
                    "collapse",
                  ],
                },
                [
                  _c("div", { staticClass: "input-group-prepend" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-change-date left",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.decrementStartDateCalendar()
                          },
                        },
                      },
                      [
                        _c("font-awesome-icon", {
                          attrs: { icon: "angle-left" },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _c("div", { staticClass: "year-value text-center" }, [
                    _c(
                      "div",
                      { staticClass: "row" },
                      _vm._l(_vm.startDateYearsArray, function (year, index) {
                        return _c(
                          "button",
                          {
                            key: index,
                            class: [
                              {
                                "current-year":
                                  year === _vm.data.selected.startDate,
                              },
                              {
                                "not-available-year":
                                  year > _vm.data.selected.endDate,
                              },
                              "col-3 btn-year",
                            ],
                            on: {
                              click: function ($event) {
                                return _vm.setStartDate(year)
                              },
                            },
                          },
                          [_vm._v(" " + _vm._s(year) + " ")]
                        )
                      }),
                      0
                    ),
                  ]),
                  _c("div", { staticClass: "input-group-append" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-change-date right",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.incrementStartDateCalendar()
                          },
                        },
                      },
                      [
                        _c("font-awesome-icon", {
                          attrs: { icon: "angle-right" },
                        }),
                      ],
                      1
                    ),
                  ]),
                ]
              ),
            ]),
          ]),
          _c("div", { staticClass: "col-5" }, [
            _c("h6", { staticClass: "picker-title" }, [
              _vm._v(" " + _vm._s(_vm.$t("finishingDate")) + " "),
            ]),
            _c("div", { staticClass: "year-range-input mb-0 mt-1" }, [
              _c(
                "div",
                {
                  staticClass: "input-group",
                  class: { "calendar-open": _vm.endDateCalendarOpen === true },
                },
                [
                  _c("div", { staticClass: "input-group-prepend" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-change-date left",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.data.decrementEndDate()
                          },
                        },
                      },
                      [
                        _c("font-awesome-icon", {
                          attrs: { icon: "angle-left" },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _c(
                    "div",
                    {
                      staticClass: "year-value text-center",
                      on: {
                        click: function ($event) {
                          return _vm.openEndDateCalendar()
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.data.selected.endDate) + " ")]
                  ),
                  _c("div", { staticClass: "input-group-append" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-change-date right",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.data.incrementEndDate()
                          },
                        },
                      },
                      [
                        _c("font-awesome-icon", {
                          attrs: { icon: "angle-right" },
                        }),
                      ],
                      1
                    ),
                  ]),
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "input-group",
                  class: [
                    { "show calendar": _vm.endDateCalendarOpen === true },
                    "collapse",
                  ],
                },
                [
                  _c("div", { staticClass: "input-group-prepend" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-change-date left",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.decrementEndDateCalendar()
                          },
                        },
                      },
                      [
                        _c("font-awesome-icon", {
                          attrs: { icon: "angle-left" },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _c("div", { staticClass: "year-value text-center" }, [
                    _c(
                      "div",
                      { staticClass: "row" },
                      _vm._l(_vm.endDateYearsArray, function (year, index) {
                        return _c(
                          "button",
                          {
                            key: index,
                            class: [
                              {
                                "current-year":
                                  year === _vm.data.selected.endDate,
                              },
                              {
                                "not-available-year":
                                  year < _vm.data.selected.startDate,
                              },
                              "col-3 btn-year",
                            ],
                            on: {
                              click: function ($event) {
                                return _vm.setEndDate(year)
                              },
                            },
                          },
                          [_vm._v(" " + _vm._s(year) + " ")]
                        )
                      }),
                      0
                    ),
                  ]),
                  _c("div", { staticClass: "input-group-append" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-change-date right",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.incrementEndDateCalendar()
                          },
                        },
                      },
                      [
                        _c("font-awesome-icon", {
                          attrs: { icon: "angle-right" },
                        }),
                      ],
                      1
                    ),
                  ]),
                ]
              ),
              _c(
                "button",
                {
                  staticClass: "btn btn-primary btn-refresh btn-sm mt-2",
                  attrs: {
                    type: "button",
                    "data-toggle": "collapse",
                    "data-target": "#planner",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.refreshRouterFromCalendar()
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$t("refresh")) + " ")]
              ),
            ]),
          ]),
        ]),
      ]),
      _c("plant-modal", { ref: "plantModal" }),
      _c("unit-modal", { ref: "unitModal" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }